<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Integração Produtos
        </p>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>

        <lista-unidades-select v-model="unidade.nome"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm texto-titulo-input">Status Integração</div>
        <q-select
          v-model="filtros.statusIntegracao"
          :options="options.statusIntegracao"
          dense
          outlined
          class="select"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          label="Atualizar Integração"
          color="positive"
          no-caps
          icon="sync"
          @click="atualizarIntegracao()"
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          label="Filtrar"
          color="primary"
          no-caps
          icon="filter_alt"
          @click="listarProdutos()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg justify-between items-center"></div>
      <q-table
        :columns="columns"
        :rows="listaProdutosIntegracao"
        :loading="loading"
        color="primary"
        style="max-height: 500px"
        dense
        class="tabela-tamanho-fixo"
        :rows-per-page-options="[0]"
        table-header-class="bg-accent text-weight-bold"
        selection="single"
        v-model:selected="selected"
        hide-pagination
        flat
        row-key="id"
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.busca"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos Listados da Integração.</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-9">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong
                    >{{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong
                    >{{ props.row.nome_epi }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cod. CA SOC: </strong
                    >{{ props.row.codigo_integracao_ca }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cod. Integração: </strong
                    >{{ props.row.codigo_integracao_epi }}</span
                  >
                  <span class="row col-12 items-center q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Cod. Interno: </strong>
                    <span v-if="!props.selected">{{
                      props.row.codigo_epi
                    }}</span>
                    <input
                      v-else
                      v-model="codigoEpi"
                      type="text"
                      class="input-codigo-epi-grid"
                    />
                  </span>
                </div>
                <div class="row col-3 justify-around">
                  <div>
                    <q-btn
                      v-if="!props.selected"
                      icon="edit"
                      color="primary"
                      flat
                      round
                      @click="props.selected = !props.selected"
                    />
                    <q-btn
                      v-else
                      icon="done"
                      flat
                      color="positive"
                      round
                      @click="atualizarCodigoEpi(props.row.id)"
                    />
                  </div>
                  <div>
                    <q-btn
                      icon="content_copy"
                      color="orange-5"
                      round
                      @click="duplicar(props.row.id, props.row.codigo_epi)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span> {{ props.row.id }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.nome_epi }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.codigo_integracao_ca }}</span>
            </q-td>
            <q-td>
              <span> {{ props.row.codigo_integracao_epi }}</span>
            </q-td>
            <q-td>
              <span v-if="!props.selected"> {{ props.row.codigo_epi }}</span>
              <q-input
                v-else
                style="width: 130px"
                dense
                outlined
                v-model="codigoEpi"
              />
            </q-td>
            <q-td>
              <q-btn
                v-if="!props.selected"
                icon="edit"
                color="primary"
                flat
                round
                @click="props.selected = !props.selected"
              />
              <q-btn
                v-else
                icon="done"
                color="positive"
                flat
                round
                @click="atualizarCodigoEpi(props.row.id)"
              />
            </q-td>
            <q-td>
              <q-btn
                icon="content_copy"
                flat
                color="orange-5"
                round
                @click="duplicar(props.row.id, props.row.codigo_epi)"
              />
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns2"
        :rows="listaProdutos"
        :loading="loading2"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filtros.buscaProduto"
            type="text"
            class="col-md-3 col-xs-12"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos do Catálogo.</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-9">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Código: </strong>
                    {{ props.row.code }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Nome: </strong>
                    {{
                      props.row.pivot?.contract_product_description ||
                      props.row.name
                    }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">CA: </strong>
                    {{ props.row.ca?.code }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Grupo: </strong>
                    {{ props.row.pivot.product_group?.name }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Categoria: </strong>
                    {{ props.row.pivot.product_category?.description }}</span
                  >
                </div>
                <div class="col-2"></div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.code }}
          </q-td>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{
              props.row.pivot?.contract_product_description || props.row.name
            }}
          </q-td>
        </template>
        <template v-slot:body-cell-ca="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.ca?.code }}
          </q-td>
        </template>
        <template v-slot:body-cell-grupo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.pivot.product_group?.name }}
          </q-td>
        </template>
        <template v-slot:body-cell-categoria="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.pivot.product_category?.description }}
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref, watch, onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";

const columns = [
  {
    name: "codigo",
    label: "ID",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome EPI",
    align: "left",
  },
  {
    name: "codcacsoc",
    label: "Cod. CA SOC",
    align: "left",
  },
  {
    name: "codintegracao",
    label: "Cod. Integração",
    align: "left",
  },
  {
    name: "codinterno",
    label: "Cod. Interno",
    align: "left",
  },
  {
    name: "salvar",
    label: "Editar",
    align: "left",
  },
  {
    name: "copiar",
    label: "Copiar",
    align: "left",
  },
];
const columns2 = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "ca",
    label: "CA",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "categoria",
    label: "Categoria",
    align: "left",
  },
];
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const filtros = ref({
      statusIntegracao: {
        label: "Integrados",
        value: 1,
      },
      busca: "",
      buscaProduto: "",
    });
    const options = {
      statusIntegracao: [
        { label: "Integrados", value: 1 },
        { label: "Não Integrados", value: 0 },
      ],
    };
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    const listaProdutos = ref([]);
    const listaProdutosIntegracao = ref([]);

    const selected = ref([]);
    let disable = ref(false);
    let loading = ref(false);
    let loading2 = ref(false);
    const codigoEpi = ref("");

    const listarProdutos = async (page = 0, rowsPerPage = 6) => {
      await unidade.value.id;
      listarProdutosIntegracao();
      try {
        loading2.value = true;
        disable.value = true;
        const response = await store.dispatch("integracao/listarProdutos", {
          per_page: rowsPerPage,
          page: page,
          vendor_id: store.state.org.contract,
          search: filtros.value.buscaProduto,
        });
        listaProdutos.value = response.data.model.products.data;
        pagination.value.rowsPerPage = response.data.model.products.per_page;
        pagination.value.page = response.data.model.products.current_page;
        pagination.value.rowsNumber = response.data.model.products.total;
        loading2.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const listarProdutosIntegracao = async () => {
      try {
        loading.value = true;

        const response = await store.dispatch(
          "integracao/listarEpisIntegracao",
          {
            per_page: 100,
            nome: filtros.value.busca,
            unidade_codigo: unidade?.value?.nome.codigoIntegracaoUnidade,
            possui_codigo_epi: filtros.value.statusIntegracao.value,
          }
        );
        listaProdutosIntegracao.value = response.data.results.data;
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const atualizarIntegracao = async () => {
      try {
        await store.dispatch("integracao/atualizarIntegracao", {
          job: "AtualizarCadastroEpisJob",
          vendor_id: unidade.value.id,
        });
        quasar.notify({
          message: "Atualização sendo processada",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao tentar processar atualização",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const atualizarCodigoEpi = async (epiId) => {
      if (codigoEpi.value == "") {
        selected.value = [];
        return;
      }
      try {
        await store.dispatch("integracao/atualizarCodigoEpi", {
          codigo_epi: codigoEpi.value,
          epi_id: epiId,
        });
        quasar.notify({
          message: "Código alterado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        selected.value = [];
        codigoEpi.value = "";
        listarProdutosIntegracao();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao alterar código",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const duplicar = async (id, codigo) => {
      try {
        await store.dispatch("integracao/duplicar", {
          product_id: id,
          codigo_epi: codigo,
        });
        quasar.notify({
          message: "Duplicado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarProdutosIntegracao();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao duplicar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const paginarTabela = async () => {
      listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value.nome = store.state.org.unidadeData;
        unidade.value.id = store.state.org.unidadeData.id;
      }
    );

    watch(
      () => filtros.value.busca,
      () => {
        listarProdutosIntegracao();
      }
    );

    watch(
      () => filtros.value.buscaProduto,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => filtros.value.statusIntegracao,
      () => {
        listarProdutosIntegracao();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");

        unidade.value.nome = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    onMounted(listarProdutos);
    onMounted(listarProdutosIntegracao);

    return {
      columns,
      columns2,
      unidade,
      options,
      filtros,
      listarProdutos,
      listarProdutosIntegracao,
      listaProdutos,
      listaProdutosIntegracao,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      loading2,
      selected,
      atualizarIntegracao,

      codigoEpi,
      atualizarCodigoEpi,
      duplicar,
      paginarTabela,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
  .btn-exportar {
    font-size: 12px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .input-multiplo-grid {
    width: 100px;
  }
  .input-codigo-epi-grid {
    width: 70px;
    outline: none;
  }
}
</style>
